/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react";
import PropTypes from "prop-types";
import Helmet from "react-helmet";
import { useStaticQuery, graphql, withPrefix } from "gatsby";

function SEO({ description, lang, meta, title, image, canonical, url }) {
  const {
    site,
    siteBuildMetadata,
    wp: { themes },
  } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
            siteUrl
            gdprConsentScriptUrl
          }
        }
        siteBuildMetadata {
          buildTime
        }
        wp {
          themes: acfThemeGeneralSettings {
            options: acfThemeOptions {
              logo {
                sourceUrl
              }
            }
          }
        }
      }
    `
  );

  const metaDescription = description || site.siteMetadata.description;

  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      script={[
        {
          type: "application/ld+json",
          innerHTML:
            '{"@context": "https://schema.org", "@type": "Organization", "name": "Mediebyrået Enklere Valg", "url": "https://www.enklerevalg.no", "logo": { "@type": "ImageObject", height: "75px", width: "75px", "url": "' +
            themes.options.logo?.sourceUrl +
            '"}}',
        },
        site.siteMetadata.gdprConsentScriptUrl
          ? {
              type: "text/javascript",
              crossorigin: "anonymous",
              src: site.siteMetadata.gdprConsentScriptUrl,
              async: true,
              defer: true,
            }
          : null,
        {
          src: withPrefix(`script.js?v=${siteBuildMetadata.buildTime}`),
          type: "text/javascript",
          async: true,
          defer: true,
        },
      ].filter((x) => Boolean(x))}
      title={title}
      link={[
        canonical && {
          rel: `canonical`,
          href: site.siteMetadata.siteUrl + canonical,
        },
      ]}
      meta={[
        {
          name: `description`,
          content: metaDescription,
        },
        {
          name: `google-site-verification"`,
          content: `BiHjCHvFYc8DE4ICrDqpGQhfvP2rMZXqDmcHzyTe0GM`,
        },
        {
          property: `og:title`,
          content: title,
        },
        {
          property: `og:image`,
          content: image
            ? image
            : themes && themes.options && themes.options.logo?.sourceUrl,
        },
        {
          property: `og:url`,
          content: canonical
            ? site.siteMetadata.siteUrl + canonical
            : site.siteMetadata.siteUrl + url,
        },
        {
          property: `og:description`,
          content: metaDescription,
        },
        {
          property: `og:type`,
          content: `website`,
        },
        {
          name: `twitter:card`,
          content: `summary`,
        },
        {
          name: `twitter:creator`,
          content: site.siteMetadata.author,
        },
        {
          name: `twitter:title`,
          content: title,
        },
        {
          name: `twitter:description`,
          content: metaDescription,
        },
      ].concat(meta)}
    />
  );
}

SEO.defaultProps = {
  lang: `no`,
  meta: [],
  description: ``,
  image: ``,
  canonical: ``,
  url: ``,
};

SEO.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired,
  image: PropTypes.string,
  canonical: PropTypes.string,
  url: PropTypes.string,
};

export default SEO;
